import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  // 专门存放 vuex 中的数据源
  // 可以用 mapState 来简写： computed: { ...mapState(['userInfo']) }
  state: {
  
  },
  getters: {
  
  },
 //专门用来修改 state 中的值
  // 可以用 mapMutations 来简写： methods: { ...mapMutations(['changeUserInfo']) }
  mutations: {

  },
  actions: {

  },
  modules: {}
})

export default store
